import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import api from 'config/api';
import HorizontalList from 'components/HorizontalList';
import { Focusable } from 'components/navigation';

export const StyledSubTabs = styled(HorizontalList)`
  position: absolute;
  top: ${scaleSize(80)}px;
  left: ${scaleSize(120)}px;
`;

export const StyledSubTabTitleWrapper = styled(Focusable)`
  box-sizing: border-box;
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: ${scaleSize(355)}px;
  height: ${scaleSize(144)}px;
  background: ${({ theme }) => theme.imagePlaceholder};
  border-radius: ${scaleSize(12)}px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: bold;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(144)}px;
  text-align: center;
  letter-spacing: -0.333333px;
  color: ${({ theme }) => theme.defaultColor};
  margin-right: ${scaleSize(20)}px;
  padding: 0 ${scaleSize(42)}px;
  text-overflow: ellipsis;

  &.active {
    background: ${({ theme }) => theme.submenuActiveColor};
  }

  &:focus {
    background: ${({ theme }) => theme.activeColor};
    top: -${scaleSize(20)}px;
  }
`;

export const StyledCover = styled.div`
  width: ${scaleSize(335)}px;
  height: ${scaleSize(124)}px;
  margin-top: ${scaleSize(10)}px;
  margin-left: ${-scaleSize(32)}px;
  border-radius: ${scaleSize(12)}px;
  background-position: center;
  background-image: url(${({ cover }) => `${api.host}${cover}`});
`;
